module.exports = __webpack_public_path__ + "static/media/sign-in-background.6eac314f.png";